import { render, staticRenderFns } from "./OtpModal.vue?vue&type=template&id=7840e8ee&"
import script from "./OtpModal.vue?vue&type=script&lang=js&"
export * from "./OtpModal.vue?vue&type=script&lang=js&"
import style0 from "./OtpModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports